import React from 'react';

function LogoMark({ width = 200, height = 80, color = "#8A9A5B", style = {} }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 500 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M50 140 C 120 140, 160 140, 190 110 C 220 80, 210 40, 185 45 C 165 50, 155 80, 155 80 C 155 80, 145 50, 125 45 C 100 40, 90 80, 120 110 C 150 140, 190 140, 260 140 L 450 140"
        stroke={color}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LogoMark;
